import React from 'react';
import { SvgIconProps } from './types';
import StyledSvgIcon from './SvgIcon.style';

const SvgIcon: React.FC<SvgIconProps> = ({
  src = '',
  rotate = 0,
  width = '7rem',
  height = '7rem',
  bgColor = '#fff',
  bgImage = undefined,
  className = '',
}: SvgIconProps) => {
  return (
    <StyledSvgIcon
      className={`svg-icon${className && ` ${className}`}`}
      src={src}
      rotate={rotate}
      width={width}
      height={height}
      bgColor={bgColor}
      bgImage={bgImage}
    />
  );
};

export default SvgIcon;
